import RetrievalDocumentUploadForm from "./RetrievalDocumentUploadForm";
import { uploadToADLS } from "./GuardianshipBondRetrieveHelpers";
import { RETRIEVE_PII_ACCESS } from "./bondRetrieveSharedPropTypes";

const GUARDIANSHIP_SECTIONS = [
  { label: "Court Order", name: "courtOrder" },
  { label: "Last Will", name: "lastWill" },
  { label: "Other Document", name: "otherDocument" },
  { label: "Bond Application", name: "bondApp" },
  { label: "Bond", name: "bond" },
  { label: "Indemnity Document", name: "indemnity" },
  { label: "Cancellation Document", name: "cancellationDocument" },
  { label: "Endorsement Document", name: "endorsementDocument" },
  { label: "Endorsement POA Document", name: "endorsementPOADocument" },
  { label: "Credit Report Document", name: "creditDocument" },
  { label: "FCRA Document", name: "fcraDocument" },
];

const GuardianshipDocumentUpload = (props) => (
  <RetrievalDocumentUploadForm
    {...props}
    uploadToADLS={uploadToADLS}
    sections={GUARDIANSHIP_SECTIONS}
  />
);

GuardianshipDocumentUpload.propTypes = RETRIEVE_PII_ACCESS;

export default GuardianshipDocumentUpload;
